module.exports = __webpack_public_path__ + "web_static/img/right_black.955f1adc.png";